import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Card, CardBlock, Row, Col } from 'reactstrap';
import Pagination from 'rc-pagination';
import { Button, Input, Table, Modal } from 'antd';
import { toastr } from 'react-redux-toastr';
import * as actionCustomer from './../../../actions/customer';
import * as actionUser from './../../../actions/user';

@connect(
  state => ({
    userState: state.get('User'),
    customerState: state.get('Customer')
  }),
  dispatch => ({
    customerAction: bindActionCreators(actionCustomer, dispatch),
    userAction: bindActionCreators(actionUser, dispatch)
  })
)

export default class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      userList: {},
    };
  }
  componentWillMount() {
    const { userAction, customerAction } = this.props;
    customerAction.fetchCustomerNameList();
    userAction.fetchGetUserinfo({ page: this.state.page, limit: this.state.limit })
      .then(() => { this.handleData(); });
  }
  // props 改变时调用
  componentWillReceiveProps(nextProps) {
    const { customerState } = nextProps;
    const { data } = (customerState && customerState.toJS().data) || {};
    // console.log('123#########################', data);
    this.setState({ customerName: data });
  }
  // 设置经销商
  setCustomer = (value) => {
    this.setState({
      customer: (value && value.id) || ''
    })
  }
  handleData = () => {
    const { userState } = this.props;
    const { data } = userState && userState.toJS().data;
    this.setState({ userList: data });
  };
  freeze = (value) => {
    const confirm = Modal.confirm;
    confirm({
      title: '提示',
      content: '是否需要进行此操作？',
      onOk: () => {
        console.log('_____________________', value.freeze);
        const { userAction } = this.props;
        let isTrue = value.freeze;
        if (isTrue) {
          isTrue = false;
        } else {
          isTrue = true;
        }
        userAction.fetchGetUserFreeze({ isTrue: isTrue, id: value.id })
          .then(() => { this.pageChange(this.state.page); })
      },
      onCancel: () => {
      }
    });
  }
  delete = (value) => {
    const confirm = Modal.confirm;
    confirm({
      title: '提示',
      content: '是否删除此用户？',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: () => {
        const { userAction } = this.props;
        userAction.fetchGetUserDelete({ userId: value.id })
          .then(() => { this.pageChange(this.state.page); });
        toastr.success('删除成功!');
      },
      onCancel: () => {
      }
    })
  }
  search = () => {
    const { page, customer, username, phone } = this.state;
    const { userAction } = this.props;
    userAction.fetchGetUserinfo({ page: page, customerId: customer, username: username, phone: phone })
      .then(() => { this.handleData(); })
  }
  typein = field => (e) => {
    this.setState({ [field]: e.target.value });
  }
  pageChange = (page) => {
    this.setState({ page: page })
    const { customer, username, phone } = this.state;
    const { userAction } = this.props;
    userAction.fetchGetUserinfo({ page: page, customerId: customer, username: username, phone: phone })
      .then(() => { this.handleData(); })
  }
  render() {
    const { userList, customer, customerName } = this.state;
    const columns = [
      { title: '经销商', dataIndex: 'name' },
      { title: '用户', dataIndex: 'username' },
      { title: '电话', dataIndex: 'phone' },
      { title: '是否冻结', dataIndex: 'freeze', render: (text, record) => <div>{record.freeze === false ? '未冻结' : '冻结'}</div> },
      {
        title: '操作',
        dataIndex: '_id',
        render: (text, record) => <div><Button type="primary" onClick={() => this.freeze(record)}>{record.freeze === false ? '冻结' : '解冻'}</Button>&nbsp;&nbsp;&nbsp;&nbsp;<Button type="primary" onClick={() => this.delete(record)}>删除</Button></div>
      }]
    return (
      <Card>
        <CardBlock>
          <Row className="form-group">
            <Col md="12">
              <div className="input-group mb-2">
                <Col md="2">
                  <Select
                    placeholder="选择对应经销商"
                    labelKey="name"
                    valueKey="id"
                    value={customer || ''}
                    options={customerName}
                    onChange={e => this.setCustomer(e)}
                  />
                </Col>
                <Col md="2">
                  <Input placeholder="用户名" onChange={this.typein('username')} />
                </Col>
                <Col md="2">
                  <Input placeholder="电话" onChange={this.typein('phone')} />
                </Col>
                <Col md="1">
                  <span className="input-group-btn">
                    <button size="large" onClick={this.search} className="btn btn-primary btn-pointer"><i className="fa fa-search" /> </button>
                  </span>
                </Col>
              </div>
            </Col>
          </Row>
          <Row className="form-group">
            <Col md="12">
              <Table
                pagination={false}
                rowkey="id"
                borderedhandleData
                columns={columns}
                dataSource={userList.docs}
                showHeader="false"
                size="middle"
              />
              <div className="card-block">
                <Pagination
                  showLessItems
                  current={this.state.page}
                  // pageSize={this.state.limit}
                  onChange={this.pageChange}
                  ShowTotal={(total, range) => `${range[0]}-${range[1]} 共 ${total}`}
                  total={userList.total}
                />
              </div>
            </Col>
          </Row>
        </CardBlock>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/App/User/index.js